import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  QueryList,
  OnDestroy,
} from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { Observable, of } from 'rxjs';
import {
  GridData,
  DataStateChangeEvent,
  Sort,
} from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { PendingProposalPartInfo } from 'src/app/models/internal/pendingproposalpartinfo';
import { RejectedProposalPartInfo } from 'src/app/models/internal/rejected-proposal-partinfo';
import { DueDateExtensionAppSettingsDTO } from 'src/app/models/duedateextension-appsettings-dto';
import { TeslaGridComponent } from '@tesla/angular2-tesla-common/tesla-common';
import { tap, filter } from 'rxjs/operators';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { QueryRejectedProposalDTO } from 'src/app/models/internal/query-rejectedproposal-dto';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { SourceType } from 'src/app/models/sourcetype';
import { RejectionReason } from 'src/app/models/rejection-reason';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { CopyProposalDTO } from 'src/app/models/internal/copy-proposal-dto';
import { DueDateExtensionHistoryDTO } from 'src/app/models/duedateextensionhistory-dto';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import UIHelper from 'src/app/core/utility/ui-helper';
import { PackageType } from 'src/app/models/packagetype';
import { MatDialog } from '@angular/material/dialog';
import { DuedateextensionHistoryComponent } from '../../../commonUI/duedateextension-history/duedateextension-history.component';

@Component({
  selector: 'app-Rejectedproposallist',
  templateUrl: './rejected-proposal-list.component.html',
  styleUrls: ['./rejected-proposal-list.component.scss'],
})
export class RejectedProposalListComponent extends BaseGridPage implements OnInit, AfterViewInit, ICanExportData {
  excelFilenamePrefix = "RejectedProposals_";
  RejectedProposalsForm: FormGroup;
  partProposalInfoList: RejectedProposalPartInfo[];
  rejectionReasonsList: RejectionReason[];
  partInfoIds: number[];
  isInboundShipment: boolean = true;
  allItemsCheckBoxSelected: boolean = false;
  locStorage = Constants.localStorageKeys;
  filterForm: FormGroup;
  sourceTypeList: SourceType[];
    packageTypeList: PackageType[];
  @ViewChildren(TeslaGridComponent) Grids: QueryList<TeslaGridComponent>;
  // @ViewChildren("mainGrid")
  // public Grids: QueryList<TeslaGridComponent>
  filter: SearchFilter;
  // mainGrid: TeslaGridComponent;
  tempPartinforidlist: PendingProposalPartInfo[] = [];
  public sort: Sort = {
      field: '',
      tag: '',
      ascending: true,
  };
  public formErrors = {
      itemsSelected: '',
  };
  public subscribers: any = {};
  dueDateExtensionAppSettings: DueDateExtensionAppSettingsDTO;
  filteredDDERequestHistoryList: DueDateExtensionHistoryDTO[];
  filteredAdhocDDERequestHistoryList: DueDateExtensionHistoryDTO[];
  constructor(
    private toastService: ToastService,
      private dataService: DataService,
      private fb: FormBuilder,
      private proposalService: ProposalService,
      localstorageService: LocalstorageService,
      logger: NGXLogger,
      appSettings: AppSettings,
        public formService: FormService,
      private router: Router,
      private matDialog: MatDialog
  ) {
      super(localstorageService, logger, appSettings);
      this.RejectedProposalsForm = this.fb.group({
          itemsSelected: [null]
      });
      this.filterForm = this.fb.group({
        PartNumber: [null],
        SourceTypeId: [null],
        RejectionReasonId: [null],
          PackageTypeId: [null]
    });
    this.dueDateExtensionAppSettings = new DueDateExtensionAppSettingsDTO();

  }

  ngOnInit() {
      this.initFilterValues();
      this.getSourceTypes();
      this.getRejectionReasons();
      this.getPackageTypes();
      this.getDueDateExtensionAppSettings();
      this.fillGrid();
  }

  fillGrid(): void {
      // const CurrentSupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode);
      this.filter.Skip = this.skip;
      this.filter.Take = this.pageSize;
      this.allItemsCheckBoxSelected = false;
      const queryRejectedProposalDTO: QueryRejectedProposalDTO = {
          // SupplierCode: CurrentSupplierCode,
          SearchFilter: this.filter
      };
      this.getRejectedProposals(queryRejectedProposalDTO);
  }

  exportData()
  {
      const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
      const queryRejectedProposalDTO: QueryRejectedProposalDTO = {
        SearchFilter: this.filter
    };
      this.dataService      
      .getRejectedProposalsExcel(queryRejectedProposalDTO)
      .subscribe((response: any) => {
          if (response != null && response.Success) {
              UIHelper.DownloadExcelFile(response.Data, filename);
          } else {
              this.toastService.error(
                  'Could not export data'
              );
          }
      });
  }


  getSourceTypes() {
    this.dataService.getParentSourceTypes().subscribe((response: any) => {
        if (response && response.Data != null) {
            this.sourceTypeList = response.Data;
        }
    });
  }

    getPackageTypes() {
        this.dataService.getPackageTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageTypeList = response.Data;
            }
        });
    }


  UpdateFilter() {
      this.filter.SearchFilterConditions = [];
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'RejectionReasonId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageTypeId');
    }
  clearFilter() {
        this.filter.SearchFilterConditions = [];
        this.pageSize = this.filter.Take = 10;
        this.filterForm.reset();
        this.search();
        this.mainGrid = undefined;
    }
  initFilterValues(): void {
      this.filter = new SearchFilter();
  }

  getRejectedProposals(queryRejectedProposalDTO: QueryRejectedProposalDTO) {
      this.UpdateFilter();
      this.dataService
          .getRejectedProposals(queryRejectedProposalDTO)
          .subscribe((response: any) => {
              // this.partInfo = response
              if (response != null) {
                  this.partProposalInfoList = response.Data;
                  this.gridView = of({
                      data: response.Data,
                      total: response.Total ? response.Total : 0,
                  });
              }
          });
  }

//   createProposal() {
//       this.ValidateForm();
//       // this.proposalService.RefreshPartInfoids([8977]);
//       if (this.RejectedProposalsForm.valid) {

//       let selectedParts = this.partProposalInfoList.filter(
//           a => a.IsSelected == true
//       );
//       // this.partInfoIds = Array.prototype.map.call(selectedParts, s => s.Id);
//       // this.proposalService.RefreshPartInfoids([8977, 687991]);
//       this.proposalService.RefreshpartInfoToBeCreatedList(selectedParts);
//       this.router.navigate(['../', 'proposal']);
//       }
//   }

// DO NOT RE-CREATE A PROPOSAL TMS-5535
//   createProposal(part: PartBasicInfo) {
//     const selectedParts: PartBasicInfo[] = [];
//     selectedParts.push(part);
//     this.proposalService.RefreshpartInfoToBeCreatedList(selectedParts);
//     // this.router.navigate(['../', 'proposal' , part['ProposalId']]);
//     const temp: PendingProposalPartInfo = new PendingProposalPartInfo();
//     temp.PartId = part['PartInfoId'];
//     temp.ProposalId = part['ProposalId'];
//     temp.SourceTypeId = part.SourceTypeId;
//     temp.PartNumber = part.PartNumber;
//     temp.POUomCode = part.POUomCode;
//     temp.IsSelected = part.IsSelected;
//     temp.Enabled = part.Enabled;
//     temp.SupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode);
//     this.tempPartinforidlist.push(temp);
//     const copyProposalDTO: CopyProposalDTO = new CopyProposalDTO();
//     copyProposalDTO.EffectiveFrom = part['EffectiveFrom'];
//     copyProposalDTO.SourceProposalId = part['ProposalId'];
//     copyProposalDTO.SourcePartInfoId = part['PartInfoId'];
//     copyProposalDTO.TargetPartInfoIdList = this.tempPartinforidlist;
//     copyProposalDTO.isForSupplier =  true;
//     copyProposalDTO.isTeslaCreated = false;
//     copyProposalDTO.Id = 0;
//     copyProposalDTO.Enabled = true;
//     copyProposalDTO.IsSelected = true;
//     this.logDebug('copying prop with dto', copyProposalDTO);
//     this.scrollToTop();
//     this.dataService
//     .copyProposal(copyProposalDTO)
//     .subscribe((response: any) => {
//         if (response != null) {
//             this.proposalService.RefreshsavedproposalIds(response.Data);
//             this.toastService.success('Proposal(s) copied to create the following records', true);
//             // this.navigateToSavedProposals();
//             // this.router.navigate(['../']);
//             this.router.navigate(['../', 'proposal' , response.Data[0]]);
//         } else {
//             this.toastService.error(
//                 'Could not copy the proposal'
//             );
//         }
//     });
// }
    navigateToSavedProposals() {
        this.router.navigate(['/saved-proposals'] );
        // window.location.href = '/saved-proposals/';

    }

  onRowSelectedChange(isSelected: boolean, partInfo: PartInfo) {
      if (isSelected) {
          this.partProposalInfoList.find(
              a => a.Id === partInfo.Id
          ).IsSelected = true;
          if (
              this.partProposalInfoList.filter(a => a.IsSelected === true)
                  .length === this.partProposalInfoList.length
          ) {
              this.allItemsCheckBoxSelected = true;
          }
          this.RejectedProposalsForm.controls[
              'itemsSelected'
          ].setErrors(null);

      } else {
          this.partProposalInfoList.find(
              a => a.Id === partInfo.Id
          ).IsSelected = false;
          this.allItemsCheckBoxSelected = false;
      }
      this.proposalService.RefreshpartInfoToBeCreatedList(
          this.partProposalInfoList
      );
  }

  setAllSelected(isSelected: boolean) {
      // this.partinfoList.map(function(part) {
      //     part.IsSelected = isSelected;
      //     return part;
      // });
      this.partProposalInfoList.forEach(part => {
          if (!this.proposalDraftCreated(part)) {
              part.IsSelected = isSelected;
          }
      });
      this.proposalService.RefreshpartInfoToBeCreatedList(
          this.partProposalInfoList
      );
  }
  getRejectionReasons() {
    this.dataService.getRejectionReasons().subscribe((response: any) => {
        // this.partInfo = data
        if (response && response.Data != null) {
            this.rejectionReasonsList = response.Data;
        }
    });
  }

  proposalDraftCreated(part: RejectedProposalPartInfo): boolean {
      return part.ProposalId > 0;
  }
  navigateToUpdateProposal(id: number) {
        this.router.navigate(['/proposal', id] );
        // window.sourceType.href = '/proposal/' + id;
    }
    viewProposal(id: number) {
        this.proposalService.RefreshproposalToViewId(id);
        window.open('viewproposal/' + id, '_blank');
    }
  ValidateForm() {
      const selectedItems = this.partProposalInfoList.filter(
          a => a.IsSelected === true
      );
      if (!selectedItems || selectedItems.length === 0) {
          this.RejectedProposalsForm.controls[
              'itemsSelected'
          ].setErrors({ selectAtLeastOneGridRow: true });
          // this.formErrors.partNumberSelection = "Please select at least one part number";
      }
      this.formErrors = this.formService.validateForm(
          <FormGroup>this.RejectedProposalsForm,
          this.formErrors
      );

  }

    setSourceTypeDesc(dataItem: RejectedProposalPartInfo) {
       return Helper.getSourceTypeToDisplay(dataItem);
    }

    getLatestRejectionReason(rejectioncomment){
        return Helper.latestRejectionComment(rejectioncomment);
    }

    /*
    TMS-16560-Add function which will allow to delete rejected proposals
    */
    deleteProposal(proposal) {
        if (Helper.confirmDeleteAction()) {
            this.dataService.deleteProposal(proposal.ProposalId).subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.toastService.success('Proposal deleted successfully', true);
                    this.fillGrid();
                } else {
                    this.toastService.error(
                        'Could not delete the proposal'
                    );
                }
            });
        }
    }

    //TMS-19213 Get PackageTypeDescription to display on table 
    getPackageType(packageTypeId) {
        return Helper.getPackageTypeDescription(packageTypeId);
    }
    formatDate(unformattedDate: Date) {
        return Helper.formatDate(unformattedDate);
      }

      onDueDateClick(pendingProposalPartInfoDto: PendingProposalPartInfo) {
        const dialogRef = this.matDialog.open(DuedateextensionHistoryComponent, {
            height: '730px',
            width: '750px',
            data: pendingProposalPartInfoDto
        });
        dialogRef.afterClosed().subscribe(result => {
           // Reload pending proposals only if user revises the due date.
            if (dialogRef.componentInstance.dueDateExtensionForm.controls['revisedDueDate'].value) {
                this.fillGrid();
            }     
            //Reload pending proposals when Adhoc DDE requested  
            // var filteredAdhocDDERequestSize = this.partProposalInfoList.filter(x => x.DueDateExtensionHistory.filter(x => x.AdHocDueDateExtensionRequestStatusId != null))
            // if (filteredAdhocDDERequestSize.length > 0) {
            //     this.fillGrid();
            // } 
        });
    }

    getDueDateExtensionAppSettings() {
        this.dataService.getDueDateExtensionAppSettings()
                .subscribe((response: any) => {
                    if (response &&
                        response.Success &&
                        response['Data']) {
                        const dueDateExtensionAppSettingsDto = response['Data'];
                        if (!dueDateExtensionAppSettingsDto ||
                            !dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_DAYS_DUE_DATE_EXTENSION] ||
                            !dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_NO_OF_TIMES_DUE_DATE_EXTENSION] ||
                            !dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_OFFSET_DAYS_FOR_DUE_DATE_EXTENSION]) {
                            this.toastService.error('Could not fetch the Due Date Extension App Settings.');
                            return;
                        }
                        this.dueDateExtensionAppSettings.MaxDaysDueDateExtension = parseInt(dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_DAYS_DUE_DATE_EXTENSION]);
                        this.dueDateExtensionAppSettings.MaxNoOfTimesDueDateExtension = parseInt(dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_NO_OF_TIMES_DUE_DATE_EXTENSION]);
                        this.dueDateExtensionAppSettings.MaxOffsetDaysForDueDateExtension = parseInt(dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_OFFSET_DAYS_FOR_DUE_DATE_EXTENSION]);
                       // this.toastService.success('Fetched the Due Date Extension App Settings successfully.');
                    } else {
                        this.toastService.error('Could not fetch the Due Date Extension App Settings.');
                    }
                });
    }
    getLatestDueDate(dataItem: any) {
        const ddeHistory = dataItem.DueDateExtensionHistory;
        this.filteredAdhocDDERequestHistoryList = ddeHistory.filter(x => x.AdHocDueDateExtensionRequestStatusId == Constants.AdhocDDE_APPROVED_STATUS_ID);
        this.filteredDDERequestHistoryList = ddeHistory.filter(x => x.AdHocDueDateExtensionRequestStatusId == null);
        const filteredAhocDDERListSize = this.filteredAdhocDDERequestHistoryList.length;
        const filteredDDERListSize = this.filteredDDERequestHistoryList.length;
        let latestADhocDueDate: Date;
        let latestDueDate: Date;

        //Get more recent regular requested duedate if exists else return original DueDate
        if (filteredDDERListSize > 0) {
            latestDueDate = this.filteredDDERequestHistoryList[filteredDDERListSize - 1].RevisedDueDate;
        }
        else {
            return this.formatDate(dataItem.DueDate);
        }

        //Get more recent approved adhoc due date if exists  
        if (filteredAhocDDERListSize > 0) {
            latestADhocDueDate = this.filteredAdhocDDERequestHistoryList[filteredAhocDDERListSize - 1].RevisedDueDate;
        }

        //check if there is no adhoc request then return latest dd requested.
        if (latestDueDate != null && latestADhocDueDate == null) {
            return this.formatDate(latestDueDate);
        }
        //Check if regular dd request is greater than adhoc dd
        else if (latestDueDate > latestADhocDueDate) {
            return this.formatDate(latestDueDate);
        }
        else {
            return this.formatDate(latestADhocDueDate);
        }    
    } 
    
}
